export default __webpack_public_path__ + "static/media/Icon.2db7de44.svg";